import { render, staticRenderFns } from "./readerEquipment.vue?vue&type=template&id=496db3c4&scoped=true"
import script from "./readerEquipment.vue?vue&type=script&lang=js"
export * from "./readerEquipment.vue?vue&type=script&lang=js"
import style0 from "./readerEquipment.vue?vue&type=style&index=0&id=496db3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496db3c4",
  null
  
)

export default component.exports